import { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useCurrentUser } from './auth'
import { visiblePhases } from './phases'
import { SegmentedTabs } from './components/SegmentedTabs'

/**
 * Hlavní stránka modulu: horní přepínač fází + obsah zvolené fáze.
 * Viditelnost fází řídí tenant (Apex vs. Imperium) a role (CEO).
 * Vzhled dědí z aplikace (rám dodává NewLayout v OpsRoot) — modul si vlastní
 * theme nenese, jinak by ignoroval vzhled zvolený podle teritoria.
 */
export function OpsPage() {
  const user = useCurrentUser()
  const phases = visiblePhases(user)
  const [activeKey, setActiveKey] = useState(phases[0]?.key ?? '')

  // Po změně uživatele (tenant/role) může aktivní fáze zmizet — spadni na první viditelnou.
  useEffect(() => {
    if (!phases.some((p) => p.key === activeKey)) {
      setActiveKey(phases[0]?.key ?? '')
    }
  }, [phases, activeKey])

  const active = phases.find((p) => p.key === activeKey) ?? phases[0]
  if (!active) {
    return <Typography sx={{ p: 3 }}>Nemáte přístup k žádné části modulu.</Typography>
  }
  const ActiveComponent = active.component

  return (
    <Box>
      <SegmentedTabs
        items={phases.map((p) => ({ value: p.key, label: p.label }))}
        value={active.key}
        onChange={setActiveKey}
      />
      <Box sx={{ mt: 3 }}>
        <ActiveComponent />
      </Box>
    </Box>
  )
}
